require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-stinatz.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-stinatz");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-stinatz!./.cache/json/betreuungseinrichtungen-guessing-stinatz.json
// module id = 904
// module chunks = 231608221292675